import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Radio, Dices, BarChart3, Sun, Moon } from "lucide-react";

export const NavBar = () => {
  const { pathname } = useLocation();
  const [dark, setDark] = useState(() =>
    typeof document !== "undefined" && document.documentElement.classList.contains("dark")
  );

  const toggleTheme = () => {
    const el = document.documentElement;
    const next = !el.classList.contains("dark");
    el.classList.toggle("dark", next);
    try { localStorage.setItem("theme", next ? "dark" : "light"); } catch (err) { console.warn("Gagal simpan tema ke localStorage", err); }
    setDark(next);
  };

  const tabs = [
    { to: "/", label: "Result 4D", icon: Radio, key: "4d" },
    { to: "/lotto-5d6d", label: "5D / 6D", icon: Dices, key: "5d6d" },
    { to: "/statistik", label: "Statistik", icon: BarChart3, key: "stats" },
  ];

  return (
    <div className="sticky top-0 z-50 border-b border-slate-200 bg-white/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1500px] items-center justify-between gap-3 px-4 py-3 sm:px-6">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-brand">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-900">
            <Radio className="h-5 w-5 text-emerald-400" />
          </span>
          <div>
            <h1 className="font-display text-xl font-black tracking-tight text-slate-900 sm:text-2xl">LIVE RESULT IN ONE PLACE</h1>
            <p className="hidden text-[11px] text-slate-500 sm:block">created by @Mrjimie</p>
          </div>
        </Link>

        <div className="flex items-center gap-2">
          <nav className="flex items-center gap-1 rounded-full border border-slate-200 bg-slate-50 p-1" data-testid="main-nav">
            {tabs.map((t) => {
              const active = pathname === t.to;
              const Icon = t.icon;
              return (
                <Link
                  key={t.to}
                  to={t.to}
                  data-testid={`nav-tab-${t.key}`}
                  className={`flex items-center gap-1.5 rounded-full px-2.5 py-1.5 text-sm font-semibold transition-colors sm:px-4 ${
                    active ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-200/60"
                  }`}
                >
                  <Icon className="h-4 w-4" /> <span className="hidden sm:inline">{t.label}</span>
                </Link>
              );
            })}
          </nav>

          <button
            data-testid="theme-toggle"
            onClick={toggleTheme}
            aria-label="Tukar tema"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 transition-colors hover:bg-slate-100"
          >
            {dark ? <Sun className="h-5 w-5 text-amber-400" /> : <Moon className="h-5 w-5" />}
          </button>
        </div>
      </div>
    </div>
  );
};
